import FieldTypesEnum from '../Enums/FieldTypesEnum';
import React from 'react';
import FaIcon from '../Elements/FaIcon';

export default class MetaItem {
  constructor(item) {
    if (item == null) {
      this.MetaId = '';
      this.DisplayName = '';
      this.SheetName = '';
      this.TableName = '';
      this.SourceFunctionName = '';
      return;
    }
    this.MetaId = item.metaId;
    this.DisplayName = item.displayName;
    this.SheetName = item.sheetName;
    this.TableName = item.tableName;
    this.SourceFunctionName = item.sourceFunctionName;
  }

  static NameOfTheIdField() {
    return 'MetaId';
  }

  static nameOfTheItemDetailList() {
    return 'Meta';
  }

  static MoneyFields = [];

  static Currency() {}

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {}

  static DateFields = [];

  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Display Name', orderById: 'DisplayName', data: 'DisplayName', minWidth: 50 },
      { label: 'Sheet Name', orderById: 'SheetName', data: 'SheetName', minWidth: 50 },
      { label: 'Table Name', orderById: 'TableName', data: 'TableName', minWidth: 50 },
      { label: 'Source Function Name', orderById: 'SourceFunctionName', data: 'SourceFunctionName', minWidth: 50 },
      {
        label: 'Meta Operations',
        orderById: '',
        data: (item) => (
          <div>
            <FaIcon
              iconName='fa-regular fa-trash-can'
              className='text-primary p-1'
              onClick={() => MetaItem.removeMetaFunction(item.MetaId, item)}
              key='rmremove'
              tooltipText='Remove meta'
            />
          </div>
        ),
        type: FieldTypesEnum.PureDataField,
        className: 'text-center',
      },
    ];
  }

  static removeMetaFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
